import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import pic11 from '../assets/images/pic11.jpg'
import sala from '../assets/images/sala.jpg'
import ahptuslogo from '../assets/images/ahptuslogo.jpg'
import nuclyalogo from '../assets/images/nuclyalogo.jpg'
import nuclyaa from '../assets/images/nuclyaa.png'



const Generic = (props) => (
    <div>
    
        <Helmet>
            <title>AHPTUS</title>
            <meta name="description" content="Generic Page" />
        </Helmet>

        <div id="main" className="alt">
            <section id="one">
                <div className="inner">
                    <header>
                        <span className="image midlogo"><img src={ahptuslogo} alt=""/></span>
                    </header>
                    <span className="image main"><img src={sala} alt="" /></span>
                    <p>Tendo iniciado a sua atividade como entidade formadora orientada para pequenas e médias empresas, 
                    a Ahptus hoje define-se também como uma empresa de consultoria que responde às necessidades de apoio 
                    à gestão de negócios das mais diversas áreas.
                    Pretendemos ser a empresa de referência no desenvolvimento e melhoria de competências e desempenho dos nossos clientes.
                    As áreas de intervenção da Ahptus estão distribuídas por quase todos os sectores de atividade, tais como: Saúde, Serviços
                    Comércio,
                    Logística,
                    Industria Alimentar,
                    Industria Têxtil,
                    Industria Eléctrica,
                    Consultoria,
                    Restauração,
                    Construção Civil,
                    Contabilidade e Gestão,
                    Metalomecânica,
                    Importação e Exportação,
                    Montagem Eléctricas e 
                    Química.</p>
                    <p>A Ahptus demonstra uma preocupação constante com a melhoria contínua da 
                    qualidade dos serviços prestados aos seus clientes e a realização profissional dos seus colaboradores. 
                    </p>
                    <center><a href="https://www.ahptus.com" className="button">Saber mais</a></center> 
                </div>
                
            </section>
        </div>
        <div className="scroll-down__container">
            <section id="scrollDown" className="scrolld">
                <a href="#two"><span></span></a>
            </section>
        </div>
        <div id="main" className="alt">
            <section id="two">
                <div className="inner">
                    <header className="major">
                                <span className="image midlogo"><img src={nuclyalogo} alt=""/></span>
                    </header>
                    <span className="image main"><img src={nuclyaa} alt="" /></span>
                    <p>Na Nuclya pensamos a Saúde das pessoas numa perspetiva integrada como defende a metodologia 3´H. Na nossa opinião, só uma visão global sobre a perspetiva física, mental e emocional da pessoa nos dará o bem estar completo.</p>
                    <p> São assim 3 as áreas que temos de trabalhar para atingir a nossa visão de bem estar: a saúde, a nutrição e atividade física. Aliada a estas áreas, está transversalmente a criatividade, o foco estratégico, o espírito de equipa e a abordagem à organização de saúde no sentido de tornar a experiência do cliente única.</p>
                    <center><a href="http://www.nuclya.com/" className="button">Saber mais</a></center>
                </div>
                
            </section>
        </div>

    </div>
)

export default Generic


// WEBPACK FOOTER //
// ./src/pages/ahptus.js